import React from 'react';
import { useNavigate } from "react-router-dom";
import { DataGrid } from '@mui/x-data-grid';
import {Box, Grid, Button} from '@material-ui/core';
import {Stack, Snackbar, Alert, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormControl from '@mui/material/FormControl';
import Radio from '@mui/material/Radio';
import {MetaTags} from 'react-meta-tags';
import axios from 'axios';
import Cookies from 'js-cookie';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import LinearProgress from '@mui/material/LinearProgress';
import Tooltip from '@mui/material/Tooltip';
import Authorization from '../components/Authorization';
import InvoiceDetails from './InvoiceDetails'; 
import InvoiceSave from './InvoiceSave';
import InvoiceEdit from './InvoiceEdit';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';
import Header from "../common/HeaderMy";
import '../styles/bizofficer-a.css';
import 'font-awesome/css/font-awesome.min.css';

	var vertical='top',horizontal='center';
  
  export default function Execute() {
	const navigate = useNavigate();
	const userObj = useSelector(state => state.userDetails);	
	const isloggedin = Cookies.get('isrwadminloggedin');
	
	const childRefDetails = React.useRef();
	const childRefNew = React.useRef();
	const childRefEdit = React.useRef();
	const childRefAuthorization = React.useRef();
	const [privileges, setPrivileges] = React.useState("");
	const [dataLoading, setDataLoading] = React.useState(true);

	const [filter, setFilter] = React.useState(false);
	const [keyword, setKeyword] = React.useState("");
	const [deleteDialogShow, setDeleteDialogShow] = React.useState(false);
	const [selectedRow, setSelectedRow] = React.useState(0);
	const [dataObj, setDataObj] = React.useState({});
	const [rows, setRows] = React.useState([]);

	const [severityAlert, setSeverityAlert] = React.useState("error");
	const [showAlert, setShowAlert] = React.useState(false);
	const [alertMessage, setAlertMessage] = React.useState("");

	const authResult = new URLSearchParams(window.location.search); 
	const filterSearch = authResult.get('filter');
	
	// check if logged in
	React.useEffect(() => {
		if(!isloggedin){
			navigate('/login');
		}
	}, [isloggedin]);

	const columns = [
		{
			field: "Select",
			headerName: "",
			width: 90,
			sortable: false,
				renderCell: (cellValues) => {
				return (
				  <Radio 
					checked={cellValues.id === selectedRow}
					value={cellValues.id}
					name="radio-buttons"
					inputProps={{ 'aria-label': {cellValues} }}
				  />
				 )
			  }
		  },
		{ field: 'id', headerName: '#', width: 40 },
		{ field: 'status', headerName: 'Status', width: 140 },
		{ field: 'invoiceNumber', headerName: 'Invoice Number', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	   { field: 'grandTotalAmount', headerName: 'Amount', width: 160 },
	   { field: 'invoiceDate', headerName: 'Date',type: 'date', width: 140 },
	   { field: 'invoiceType', headerName: 'Type', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	   { field: 'accountName', headerName: 'Account', width: 160 },
		{ field: 'contactName', headerName: 'Contact Name', width: 160 },
		{ field: 'email', headerName: 'Email', width: 160 },
		{ field: 'mobile', headerName: 'Mobile', width: 160 },	
		{ field: 'billingAddress', headerName: 'Billing Address', width: 170, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },	
	   { field: 'deliveryContactName', headerName: 'Delivery Contact Name', width: 200 },
	   { field: 'deliveryEmail', headerName: 'Delivery Email', width: 160 },
	   { field: 'deliveryMobile', headerName: 'Delivery Mobile', width: 160 },	
	   { field: 'deliveryAddress', headerName: 'Delivery Address', width: 200, renderCell: (params) =>  (
			   <Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		  ), },	
		{ field: 'expectedPaymentDate', headerName: 'Expected Payment Date',type: 'date', width: 140 },
		{ field: 'receivedByAlias', headerName: 'Received By', width: 160 },
		{ field: 'receivedMobile', headerName: 'Received Mobile', width: 160 },
		{ field: 'receivedDate', headerName: 'Received Date',type: 'date', width: 140 },
		{ field: 'comment', headerName: 'Comment', width: 270, renderCell: (params) =>  (
			<Tooltip title={params.value} ><span>{params.value}</span></Tooltip>
		   ), },
	  ];

	React.useEffect(() => {		
		if(userObj.registerId && userObj.loginId && userObj.fullName && userObj.token){
			if(userObj.registerId>0 && userObj.loginId>0 && userObj.fullName.length>0 && userObj.token.length>0){
				getApiData(userObj.registerId,userObj.loginId,userObj.fullName,userObj.token);
			}
		}
	}, [userObj,filter]);

	async function getApiData(registerId,uid,fullName,token){ 
		  let queryString = '';
		  if(filterSearch){
			queryString = '&filter='+filterSearch;
		  } 
		  let apiUrl=API_URL+'/crm-list-invoices?search=1&keyword='+keyword+queryString;
		  let axiosHeader = {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': registerId,
					'uid': uid,
					'fullName': fullName,
					'token': token,
			};
			const config = {
				method: 'get',
				url: apiUrl,
				headers: axiosHeader
			}
			await axios(config)
			   .then(response => {
				setDataLoading(false);
				if(response && response.data && response.data.responseTxt==="success"){  
				 	setRows(response.data.list);	
					setPrivileges(response.data.privileges);			 				
				}else if(response && response.data && response.data.responseTxt==="invalidtoken"){
					navigate('/invalidtoken');
					
				}else if(response && response.data && response.data.responseTxt==="NoAuthorization"){
					childRefAuthorization.current.handleClickOpen();
				}
			}).catch((error) => {
				setSeverityAlert("error");
				setShowAlert(true);
				setAlertMessage(""+error);			
				return false;
		  	})	
	}

		
	
	function saveData(opt){
		if(opt===1){
			setDataObj(null);
			setSelectedRow(0);
			childRefNew.current.handleClickOpen();
		}else if(opt===2 && dataObj){
			childRefEdit.current.handleClickOpen();
		}else if(opt===3 && dataObj){
			childRefDetails.current.handleClickOpen();
		}
	}
	
	function deleteData(){
		if(dataObj && userObj.token){
			let axiosHeader = {
					headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
			  		'token': userObj.token,
				}
			}; 

		  const data = new FormData();
		  data.append('id', dataObj.autoId);
				 
		  axios.post(API_URL+'/crm-delete-invoices', data, axiosHeader)
				.then((response) => {
					///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
					setSeverityAlert("success");
					deleteDialogHide();
					setShowAlert(true);
					setAlertMessage("Invoice has been deleted.");
			  		window.location.reload();					
					return false;
				}else{
			  		setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This invoice could not be deleted.");			
					return false;
				}
			}).catch((error) => {
				///console.log("AXIOS ERROR: ", error);
			})	
		}		
		
	}

	function selectRow(obj){
		if(obj && rows[obj.id-1]){			
			setSelectedRow(rows[obj.id-1].id);
			setDataObj(rows[obj.id-1]);
		}
	}

	const handleOnCellClick = (obj) => {
		if(obj.field==='invoiceNumber'){
			setDataObj(rows[obj.id-1]);
			if(dataObj){
				childRefDetails.current.handleClickOpen();
			}
		}else if(obj.field==='accountName'){
			setDataObj(rows[obj.id-1]);
			if(dataObj && dataObj.accountNumber){
				window.location="accountdetail?accountNumber="+dataObj.accountNumber;
			}
		}		
	};

	function search(){
		setSelectedRow(0);
		setDataObj(null);
		setFilter(!filter);
	}

	function onEnter(event){
		if(event.key === 'Enter'){
			search();
		}
	}

	function deleteDialogHide(){
		setDeleteDialogShow(false);
	}

	function hideAlert(){
		setShowAlert(false);
	}

	function updatedList(list){
		setRows(list);
	}
	
	return (
		<div> 
				<MetaTags>
            		<title>Invoices</title>
          		</MetaTags>
				
				<Header hamburger={true} pageTitle="Invoices" />
				{dataLoading?<LinearProgress />:null}

				<Box className='mainBox'>	

				    <Box mt={1} mb={1} >
							<Grid container spacing={2}>
								<Grid item md={12} xs={12} >

									<FormControl style={{width:150,marginRight:60,float:'left'}}>
										<OutlinedInput 
										 id="keywordtxt"
										 placeholder="Search"
										 value={keyword}
										 onChange={event => setKeyword(event.target.value)}
										 onKeyPress={(event)=>{onEnter(event)}}
										 style={{width:200,height:40}}
										 endAdornment={
											  <InputAdornment position="end">
												<SearchIcon />
											  </InputAdornment>
											}
										 />
									</FormControl>

									<Button onClick={() => {search()}} style={{marginTop:4,float:'left',backgroundColor:'#FFF',textTransform: 'none'}} size="small" variant="contained"  >Search</Button>

									<div style={{float:'left'}}>
										{(privileges && privileges.indexOf("create")>-1)?	
											<i onClick={()=>{saveData(1)}} title="Add New" className="fa fa-plus-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
									{(selectedRow>0 && dataObj && dataObj.autoId>0)?<>
										{(privileges && privileges.indexOf("update")>-1)?	
											<i onClick={()=>{saveData(2)}} title="Edit" className="fa fa-pencil-square-o btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										{(privileges && privileges.indexOf("delete")>-1)?
											<i onClick={()=>{setDeleteDialogShow(true)}} title="Delete" className="fa fa-trash btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
										:null}
										<i onClick={()=>{saveData(3)}} title="Detail" className="fa fa-info-circle btncolor" style={{fontSize:25, marginLeft:15, cursor:'pointer'}} />
									</>:null}

										{/* <i onClick={()=>{window.location='caseskanban'}} title="View Kanban Format" className="fa fa-trello btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="View Calendar" className="fa fa-calendar btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} />
										<i onClick={()=>{window.location='caseskanban'}} title="Advance Search" className="fa fa-search btncolor" style={{fontSize:30, marginLeft:15, cursor:'pointer'}} /> */}

									</div>	
								</Grid>
							</Grid>
					</Box>

					<div className="tblReport" style={{height: '78vh', width: '100%' }}>
						<DataGrid
							rows={rows}
							columns={columns}
							pageSize={50}
							rowHeight={40}
							disableSelectionOnClick
							rowsPerPageOptions={[50]}
							ActionsComponent={()=>{alert('Hello')}}		
							style={{fontSize:12}}	
							onRowClick={itm => selectRow(itm)}	
							onCellClick={handleOnCellClick}		
							components={{
								NoRowsOverlay: () => (
								  <Stack height="100%" alignItems="center" justifyContent="center">
									<span style={{color:'#FF0000',fontWeight:'bold'}}>No record found!</span>
								  </Stack>
								)}}	
						/>
					</div>

				</Box>
				
			<InvoiceSave userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefNew} />
			<InvoiceEdit dataObj={dataObj} userObj={userObj} updatedList={updatedList} fullList={true} ref={childRefEdit}  />
			<InvoiceDetails dataObj={dataObj} userObj={userObj} ref={childRefDetails}  />						

				<Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

				<Dialog
					open={deleteDialogShow}
					onClose={deleteDialogHide}
					aria-labelledby="alert-dialog-section-title"
					aria-describedby="alert-dialog-section-description"
				>
					<DialogTitle id="alert-dialog-section-title">
						Alert
					</DialogTitle>
					<DialogContent>
					<DialogContentText id="alert-dialog-section-description">
						Are you sure, You want to delete invoice.
					</DialogContentText>
					</DialogContent>
					<DialogActions>
					<Button variant="outlined" size="small" onClick={()=>{deleteDialogHide()}}>Don't Delete</Button>
					<Button variant="contained" size="small" color="secondary" onClick={()=>{deleteData()}} autoFocus>Yes, Delete</Button>
					</DialogActions>
				</Dialog>
					
				<Authorization ref={childRefAuthorization} />			
		</div>	
	);
  }